import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import StudentPage from "./components/Student/student";
import Privacy from "./components/PrivacyPolicy/privacy";
import RecruitmentPartner from "./components/Recruitment/recruitment";
import CookiePolicy from "./components/CookiePolicy/cookie";
import Contact from "./components/ContactUs/contact";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css"
import FAQ from "./components/FAQ/faq";
import Payment from "./components/Payment/payment";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css"
// Import Bootstrap JavaScript
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/student" element={<StudentPage />} />
          <Route path="/recruitment-partner" element={<RecruitmentPartner />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/payment-terms" element={<Payment />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
